import React from 'react';

type CategoriesProps = {
  value: number;
  setCat: (i: number) => void;
};

const categories = [
  'Все',
  'Мясные',
  'Вегетарианская',
  'Гриль',
  'Острые',
  'Закрытые',
];
const Categories: React.FC<CategoriesProps> = React.memo(
  ({ value, setCat }) => {
    return (
      <div className="categories">
        <ul>
          {categories.map((categoryName, index) => (
            <li
              key={categoryName}
              onClick={() => setCat(index)}
              className={value === index ? 'active' : ''}
            >
              {categoryName}
            </li>
          ))}
        </ul>
      </div>
    );
  }
);

export default Categories;
